export const UNREQUESTED_STATE = 'unrequested';
export const LOADING_STATE = 'loading';
export const SUCCESS_STATE = 'success';
export const ERROR_STATE = 'error';
